import { useCallback } from "react";
import moment from "moment-timezone";
import { Lock } from "lucide-react";
import BreakOvertimeIndicator from "../../../../../components/BreakOvertimeIndicator";
import SectionInfo from "../../../../../components/SectionInfo";
import ShiftTooltip from "../../../../../components/tooltip/ShiftTooltip";
import { useMenuContext } from "../../../../../hooks/context/useMenuContext";
import { useEventUser } from "../../../../../hooks/useEventUser";
import { useDefaultLevel } from "../../../../../hooks/useDefaultLevel";
import { useAddedPayCode } from "../../../../../../../TimeSheet/components/TimeSheetTable/hooks/useAddedPayCode";
import { useOpenShiftPreferenceStyle } from "../../../../../hooks/styles/useOpenShiftPreferenceStyle";
import { getSectionDurations } from "../../../../../helpers/data/getSectionDurations";
import { renderSectionsDuration } from "../../../../../helpers/eventdisplay/renderSectionsDuration";
import { cn } from "../../../../../../../../lib/utils";

function OpenShift({ className, style, event, isOpen, setTooltipOpen }: any) {
    const { openMenu } = useMenuContext();
    const user = useEventUser(event?.resourceId);
    const preferenceStyle = useOpenShiftPreferenceStyle();

    const defaultPayCode = useAddedPayCode(user);
    const defaultLevel = useDefaultLevel();

    const onContextMenu = useCallback((e: any) => {
        e.preventDefault();
        e.stopPropagation();
        openMenu({
            id: "open-shift-menu",
            x: e.clientX,
            y: e.clientY + 10,
            selected: event,
            setTooltipOpen
        });
    }, [openMenu, event, setTooltipOpen]);

    const { overtimeDuration, breakDuration } = getSectionDurations(event?.sections);


    return (
        <ShiftTooltip data={{ ...event, resource: user }} isOpen={isOpen}>
            <div
                className={cn(
                    "work-block tw-rounded-sm tw-px-3 tw-py-2 tw-cursor-pointer tw-bg-white tw-border-2 tw-border-dashed",
                    "tw-flex align-center align-center tw-items-center tw-justify-center tw-absolute border-box tw-z-10",
                    className || "",
                )}
                style={{ ...style, ...preferenceStyle }}
                onContextMenu={onContextMenu}
            >
                <div className="tw-w-full">
                    <div className="tw-flex tw-flex-col">
                        <div className="tw-flex tw-items-center tw-justify-between">
                            <div className="tw-font-bold tw-text-xs tw-flex tw-items-center tw-gap-1">
                                {event?.locked && (<Lock size={12} strokeWidth={3} className="tw-mb-1" />)}
                                {renderSectionsDuration(
                                    moment(event.endDate).diff(moment(event.startDate), "seconds"),
                                    event.sections
                                )}
                            </div>

                            <BreakOvertimeIndicator
                                breakDuration={breakDuration}
                                overtimeDuration={overtimeDuration}
                            />
                        </div>

                        <SectionInfo
                            section={event?.sections?.[0]}
                            payCode={defaultPayCode?.code}
                            defaultLevel={defaultLevel}
                            className="tw-pt-0.5"
                        />
                    </div>
                </div>
            </div>
        </ShiftTooltip>
    );
}

export default OpenShift;
